import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7a8d6116"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "course-introduction"
};
const _hoisted_2 = ["innerHTML"];
export default {
  __name: 'Contact',
  props: {
    courseInfo: {
      type: Object,
      default: () => {}
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      const _component_el_empty = _resolveComponent("el-empty");
      return props.courseInfo.courseConsultation ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
        class: "contact",
        innerHTML: props.courseInfo.courseConsultation
      }, null, 8, _hoisted_2)])) : (_openBlock(), _createBlock(_component_el_empty, {
        key: 1,
        description: "暂无数据"
      }));
    };
  }
};